/* Toprank header helpers — search clear (×) button
   (Claude Design "Announcement Bar.html", 2a "Inline Finder" .sclear).
   Injects a clear pill into the header search field; clearing dispatches a
   keyup so the theme's Alpine xModalSearch state flips back to the suggest
   panel. Fields are wired lazily on first focus so ajax re-renders and the
   sticky-header clone are covered without a MutationObserver. */
(function () {
  'use strict';

  function wire(input) {
    var field = input.closest('.field') || input.parentElement;
    if (!field || field.querySelector('.tl-sclear')) return;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'tl-sclear';
    btn.setAttribute('aria-label', 'Clear search');
    btn.innerHTML = '<svg viewBox="0 0 24 24" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M18 6L6 18M6 6l12 12"/></svg>';
    field.appendChild(btn);

    function sync() { btn.classList.toggle('is-show', input.value.trim() !== ''); }
    input.addEventListener('input', sync);
    input.addEventListener('keyup', sync);
    sync();

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      input.value = '';
      sync();
      /* keyup drives xModalSearch.keyUp → empty query → suggest panel returns */
      input.dispatchEvent(new KeyboardEvent('keyup', { bubbles: true }));
      input.focus();
    });
  }

  document.addEventListener('focusin', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('.x-container-header-search .input-search')) wire(t);
  });
})();
